import ApplicationController from '../application_controller'
import Rails from '@rails/ujs'

const maxPollingRetries = 60
const pollingTimeout = 10000
const pollingInterval = 5000

export default class extends ApplicationController {
  static targets = ['progress']

  connect() {
    this._pollingRetries = 0
    this._timeout = null
    this._timeInterval = null
    if (this.hasProgressTarget) {
      this._observer = new MutationObserver(() => { this.reviewSectionsCompleted() })
      this._observer.observe(this.progressTarget, { attributes: true })
    }
  }

  disconnect() {
    this.stopPollingProcess()
  }

  reviewSectionsCompleted() {
    const readySections = this.progressTarget.value
    const totalSections = this.progressTarget.max

    if (totalSections - readySections === 0) {
      this.startPollingTimeout()
    }
  }

  stopPollingProcess() {
    this._pollingRetries = 0
    clearTimeout(this._timeout)
    clearInterval(this._timeInterval)
    this._observer?.disconnect()
  }

  startPollingTimeout() {
    this._timeout = setTimeout(() => this.startPollingProcess(), pollingTimeout)
  }

  startPollingProcess() {
    this._timeInterval = setInterval(() => this.fetchReport(), pollingInterval)
  }

  fetchReport() {
    const url = window.location.pathname
    const reportSection = document.querySelector('.c-report-section')
    const reportNotRendered = reportSection == null

    if (reportNotRendered && this._pollingRetries < maxPollingRetries) {
      this._pollingRetries += 1

      Rails.ajax({
        type: 'get',
        url: url,
        data: '',
        dataType: 'script',
        error: () => console.log('Something went wrong')
      })
    } else {
      this.stopPollingProcess()
    }
  }
}
